import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CurrencyPipe } from '@angular/common'

@Pipe({
  name: 'interpolate'
})
export class InterpolatePipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private currencyPipe: CurrencyPipe // Inyectar CurrencyPipe
  ) {}
  transform(text: string, data: { [key: string]: any }): SafeHtml {
    if (!text || !data) return this.sanitizer.bypassSecurityTrustHtml(text || '');

    // Regex para detectar {{ variable | formato }}
    const interpolatedText = text.replace(
      /\{\{\s*(\w+)(?:\s*\|\s*(\w+)(?:\(([^)]*)\))?\s*)?\}\}/g, 
      (match, key, format, formatParams) => {
        const value = data[key.trim()];
        const _value = this.applyFormat(value, format, formatParams);
        return `<span class="interpolated-value">${_value}</span>`;
      }
    );

    return this.sanitizer.bypassSecurityTrustHtml(interpolatedText);
  }

  private applyFormat(value: any, format?: string, params?: string): string {
    if (!value) return '';
    
    switch (format?.toLowerCase()) {
      case 'currency':
        const [currencyCode, display] = params ? params.split(':') : ['USD', 'symbol'];
        return this.currencyPipe.transform(
          value, 
          currencyCode?.trim() || 'USD',
          display?.trim() || 'symbol',
          '1.0-0' // Decimales (ej: 1.0-2 = 2 decimales)
        ) || '';

      
      default:
        return value.toString();
    }
  }

}
